import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { AppLocaleService } from '@core/services/app-locale.service';

@Component({
	selector: 'cass-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.css']
	// ,
	// providers: [{provide: MAT_DATE_LOCALE, useValue: 'fi-fi'}]
})
export class CalendarComponent implements OnInit {

	@ViewChild(MatCalendar)
	private _calendar?: MatCalendar<Date>;

	@Input()
	set daysSelected(dates: readonly Date[]) {
		if (!this._daysSelected || this._daysSelected.length === 0) {
			if (dates && dates.length > 0 && this._calendar) {
				// show the 1st selected date in the calendar
				this._calendar.activeDate = dates[0];
			}
		}
		this._daysSelected = dates;
	}
	get daysSelected(): readonly Date[] {
		return this._daysSelected;
	}
	private _daysSelected: readonly Date[] = [];

	@Input()
	set issueDates(issues: Date[]) {
		this._issueDates = issues;
		this.updateDependentData();
	}
	private _issueDates: Date[] = [];

	@Output()
	daysSelectedChanged = new EventEmitter<readonly Date[]>();

	minDate: Date = new Date();
	maxDate: Date = new Date(new Date().getFullYear() + 2, 0, 1);

	constructor(
		private appLocaleService: AppLocaleService) { }

	dateFormat!: string;

	ngOnInit(): void {
		this.dateFormat = this.appLocaleService.dateFormat;
		this._calendar?.updateTodaysDate();
	}

	dateClass = (event: any) => {
		const date = new Date(event);
		if (!this._daysSelected || this._daysSelected.length < 1 || this._daysSelected.findIndex(x => this.areDatesEqual(x, date)) < 0) {
			// The given date is not found in the collection of selected dates
			return [];
		}
		else {
			return "selected";
		}
	};

	toLocalFormat(d: Date) {
		const dd = formatDate(d, this.dateFormat!, this.appLocaleService.currentOrDefaultLocaleId);
		return dd;
	}

	dateFilter = (d: Date): boolean => {
		return this._issueDates.findIndex(x => this.areDatesEqual(x, d)) > -1;
	}

	select(event: any) {
		const date = new Date(event);
		const index = this._daysSelected.findIndex(x => this.areDatesEqual(x, date));

		if (index < 0) {
			// add it
			this._daysSelected = [...this._daysSelected, date].sort((a, b) => +a - +b);
		}
		else {
			// remove it
			this._daysSelected = [...this._daysSelected.slice(0, index), ...this._daysSelected.slice(index + 1)];
		}
		this.daysSelectedChanged.emit(this._daysSelected);
		this._calendar?.updateTodaysDate();
	}

	private updateDependentData() {
		if (this._issueDates && this._issueDates.length > 0) {
			this.minDate = this._issueDates[0];
			this.maxDate = this._issueDates[this._issueDates.length - 1];
		}
	}

	private areDatesEqual(date1: Date, date2: Date): boolean {
		return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
	}
}
